"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpertReviewViewTypes = void 0;
var ExpertReviewViewTypes;
(function (ExpertReviewViewTypes) {
    ExpertReviewViewTypes["PROS_CONS"] = "Pros-Cons-Review";
    ExpertReviewViewTypes["TEXT"] = "Text-Review";
})(ExpertReviewViewTypes || (exports.ExpertReviewViewTypes = ExpertReviewViewTypes = {}));
//# sourceMappingURL=ExpertReviewEnums.js.map